import React from 'react';
import Modal from 'reactstrap/lib/Modal';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import ModalBody from 'reactstrap/lib/ModalBody';
import Confetti from 'react-confetti';
import useWindowSize from 'react-use/lib/useWindowSize';
import { Button } from 'reactstrap';

import './ConfettiModal.scss';

function ConfettiModal({ title, content, closeAction }) {
  const { height } = useWindowSize();

  return (
    <>
      <Confetti
        width={1440}
        height={height}
        className="tour-confetti"
        numberOfPieces={100}
        style={{ zIndex: 999999999999999 }}
      />
      <Modal isOpen>
        <ModalHeader>
          <p className="title f-std-bold text-normal">{title}</p>
        </ModalHeader>
        <ModalBody>
          <p>{content}</p>
          <div style={{ textAlign: 'right' }}>
            <Button color="primary" size="md" onClick={closeAction}>
              <div style={{ fontFamily: 'Circular Std Black' }}>Close</div>
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
}

export default ConfettiModal;
